// 20250725
// ----------------------------
// 定数定義
// ----------------------------
const CONSTANTS = {
  REQUIRED_MARK: '<span class="socialplus-form-required-mark">※</span>',
  ERROR_COLOR: "#CE2525",
  ERROR_FONT_SIZE: "14px",
  BUTTON_STYLE: {
    width: "290px",
    minWidth: "calc(12rem + 2px)",
    minHeight: "calc(4.5rem + 2px)",
    padding: "12px 10px",
    fontSize: "16px",
    borderRadius: "2px",
    background: "#656565",
    textAlign: "center",
    display: "inline-block",
  },
  SELECT_STYLE: {
    width: "100%",
    marginTop: "8px",
  },
  CHECKBOX_STYLE: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    marginBottom: "8px",
  },
};

// ----------------------------
// フォーム要素の取得
// ----------------------------
const FormElements = {
  init() {
    const $ = (id) => document.querySelector(id);
    this.form = $("#socialplus-customer-registration-form");
    if (!this.form) return;

    this.email = $("#customer_email");

    // 姓名・カナ
    this.lastName = $("#customer_last_name");
    this.firstName = $("#customer_first_name");
    this.lastKana = $("#customer_custom_fields_0_value");
    this.firstKana = $("#customer_custom_fields_1_value");

    // 性別
    this.genderTextInput = $("#customer_custom_fields_2_value");

    // 生年月日
    this.yearSelect = $("#customer_custom_fields_3_value_1i");
    this.monthSelect = $("#customer_custom_fields_3_value_2i");
    this.daySelect = $("#customer_custom_fields_3_value_3i");
    this.dateGroup = document.querySelector(".socialplus-form-date-group");

    // 電話番号
    this.phoneInput = $("#customer_custom_fields_4_value");

    // 住所・居住国
    this.zipInput = $("#customer_custom_fields_5_value");
    this.prefectureInput = $("#customer_custom_fields_6_value");
    this.cityInput = $("#customer_custom_fields_7_value");
    this.countryInput = $("#customer_custom_fields_9_value");

    // マザーハウスを知ったきっかけ
    this.referralSourceInput = $("#customer_custom_fields_10_value");

    // 郵送DM・メールチェック同意
    this.dmConsentInput = $("#customer_custom_fields_11_value");
    this.mhMailConsentInput = $("#customer_custom_fields_12_value");
    this.eyMailConsentInput = $("#customer_custom_fields_13_value");

    // 登録ボタン
    this.submitButton = $("#socialplus_form_submit_button");
    this.submitContainer = this.submitButton
      ? this.submitButton.closest(".socialplus-form-submit")
      : null;
    if (!this.submitContainer && this.submitButton) {
      this.submitContainer = document.createElement("div");
      this.submitContainer.className = "socialplus-form-submit";
      this.submitButton.parentNode.insertBefore(
        this.submitContainer,
        this.submitButton
      );
      this.submitContainer.appendChild(this.submitButton);
    }
  },
};

// ----------------------------
// UI 操作
// ----------------------------
// 必須項目
const UI = {
  applyRequiredMarks() {
    document
      .querySelectorAll(".socialplus-form-required-mark")
      .forEach((el) => {
        el.innerHTML = "※";
        el.style.color = CONSTANTS.ERROR_COLOR;
      });

    // ヘッダー文言を変更
    const formHeader = document.querySelector(".socialplus-form-header");
    if (formHeader) {
      formHeader.textContent = "新規会員登録";
    }

    // 説明文を追加
    const formDescription = document.querySelector(
      ".socialplus-form-description"
    );
    if (formDescription) {
      const requiredText = document.createElement("p");
      requiredText.innerHTML =
        '<span style="color: ' +
        CONSTANTS.ERROR_COLOR +
        '">※</span>は必須項目です';
      requiredText.style.fontSize = "14px";
      formDescription.appendChild(requiredText);
    }
  },

  // 姓名・姓名（カナ）
  setPlaceholders() {
    const { lastName, firstName, lastKana, firstKana } = FormElements;
    if (lastName) lastName.placeholder = "姓";
    if (firstName) firstName.placeholder = "名";
    if (lastKana) lastKana.placeholder = "セイ";
    if (firstKana) firstKana.placeholder = "メイ";
  },

  adjustNameFieldStructure() {
    const { lastName, firstName, lastKana, firstKana } = FormElements;

    const lastNameLabel = document.querySelector(
      'label[for="customer_last_name"]'
    );
    const firstNameLabel = document.querySelector(
      'label[for="customer_first_name"]'
    );
    const lastKanaLabel = document.querySelector(
      'label[for="customer_custom_fields_0_value"]'
    );
    const firstKanaLabel = document.querySelector(
      'label[for="customer_custom_fields_1_value"]'
    );

    const nameGroup = lastName?.closest(".socialplus-form-field-group");
    if (nameGroup) {
      nameGroup.style.display = "block";
      nameGroup.style.marginRight = "0";
      const fields = nameGroup.querySelectorAll(".socialplus-form-field");
      fields.forEach((f) => {
        f.classList.remove("socialplus-form-field-half");
        f.style.width = "100%";
      });
    }

    const lastKanaField = lastKana?.closest(".socialplus-form-field");
    const firstKanaField = firstKana?.closest(".socialplus-form-field");
    if (lastKanaField && firstKanaField && nameGroup) {
      const kanaGroup = document.createElement("div");
      kanaGroup.className = "socialplus-form-field-kana-group clearfix";
      kanaGroup.style.marginRight = "0";
      kanaGroup.appendChild(lastKanaField);
      kanaGroup.appendChild(firstKanaField);
      nameGroup.insertAdjacentElement("afterend", kanaGroup);
    }

    if (firstNameLabel) firstNameLabel.remove();
    if (firstKanaLabel) firstKanaLabel.remove();
    if (lastNameLabel)
      lastNameLabel.innerHTML = "お名前" + CONSTANTS.REQUIRED_MARK;
    if (lastKanaLabel)
      lastKanaLabel.innerHTML = "お名前（カナ）" + CONSTANTS.REQUIRED_MARK;
  },

  // 登録ボタンの文言
  styleSubmitButton() {
    const { submitButton } = FormElements;
    if (!submitButton) return;

    submitButton.textContent = "登録 / 更新する";
    Object.assign(submitButton.style, CONSTANTS.BUTTON_STYLE);
  },
};

// ----------------------------
// 性別ラジオボタン化
// ----------------------------
function setupGenderField() {
  const { genderTextInput } = FormElements;
  if (!genderTextInput) return;

  genderTextInput.style.display = "none";
  genderTextInput.removeAttribute("required");

  const field = genderTextInput.closest(".socialplus-form-field");

  const label = field.querySelector("label");
  if (label) {
    label.innerHTML = "性別" + CONSTANTS.REQUIRED_MARK;
    label.style.fontSize = "14px";
  }

  const radioGroup = document.createElement("div");
  radioGroup.style.display = "flex";
  radioGroup.style.gap = "35px";
  radioGroup.style.marginTop = "8px";
  radioGroup.className = "gender-radio-group";

  ["男性", "女性", "その他"].forEach((labelText) => {
    const wrapper = document.createElement("label");
    Object.assign(wrapper.style, CONSTANTS.CHECKBOX_STYLE);
    const radio = document.createElement("input");
    radio.type = "radio";
    radio.name = "gender_radio";
    radio.value = labelText;
    radio.style.width = "16px";
    radio.style.height = "16px";
    radio.addEventListener("change", () => {
      genderTextInput.value = radio.value;
    });
    wrapper.appendChild(radio);
    wrapper.appendChild(document.createTextNode(labelText));
    radioGroup.appendChild(wrapper);
  });

  field.appendChild(radioGroup);
  FormElements.genderRadioGroup = radioGroup;
}

// ----------------------------
// 都道府県プルダウン化
// ----------------------------
function setupPrefectureSelect() {
  const { prefectureInput } = FormElements;
  if (!prefectureInput) return;

  const field = prefectureInput.closest(".socialplus-form-field");
  prefectureInput.style.display = "none";
  prefectureInput.removeAttribute("required");

  const select = document.createElement("select");
  select.className = "prefecture-select";
  Object.assign(select.style, CONSTANTS.SELECT_STYLE);

  const defaultOption = new Option(
    "都道府県を選択してください",
    "",
    true,
    true
  );
  select.appendChild(defaultOption);

  const prefectures = [
    "北海道",
    "青森県",
    "岩手県",
    "宮城県",
    "秋田県",
    "山形県",
    "福島県",
    "茨城県",
    "栃木県",
    "群馬県",
    "埼玉県",
    "千葉県",
    "東京都",
    "神奈川県",
    "新潟県",
    "富山県",
    "石川県",
    "福井県",
    "山梨県",
    "長野県",
    "岐阜県",
    "静岡県",
    "愛知県",
    "三重県",
    "滋賀県",
    "京都府",
    "大阪府",
    "兵庫県",
    "奈良県",
    "和歌山県",
    "鳥取県",
    "島根県",
    "岡山県",
    "広島県",
    "山口県",
    "徳島県",
    "香川県",
    "愛媛県",
    "高知県",
    "福岡県",
    "佐賀県",
    "長崎県",
    "熊本県",
    "大分県",
    "宮崎県",
    "鹿児島県",
    "沖縄県",
  ];

  prefectures.forEach((pref) => {
    select.appendChild(new Option(pref, pref));
  });

  function applyPrefectureColor() {
    select.style.color = select.value === "" ? "#999" : "";
  }

  function validatePrefecture() {
    const err = field.querySelector(".validation-error-message");
    if (!select.value) {
      if (!err) addError(select, "入力必須項目です");
      select.classList.add("has-error");
      select.style.border = `1px solid ${CONSTANTS.ERROR_COLOR}`;
    } else {
      if (err) err.remove();
      select.classList.remove("has-error");
      select.style.border = "1px solid #b9b9b9";
    }
  }

  select.addEventListener("change", () => {
    prefectureInput.value = select.value || "";
    applyPrefectureColor();
    validatePrefecture();
  });

  applyPrefectureColor();
  field.appendChild(select);
  FormElements.prefectureSelect = select;
}

// ----------------------------
// 居住国プルダウン化
// ----------------------------
function setupCountrySelect() {
  const { countryInput } = FormElements;
  if (!countryInput) return;

  const field = countryInput.closest(".socialplus-form-field");
  countryInput.style.display = "none";

  const select = document.createElement("select");
  select.className = "country-select";
  Object.assign(select.style, CONSTANTS.SELECT_STYLE);

  const countries = [
    "ー",
    "Japan",
    "China",
    "HongKong",
    "Taiwan",
    "Republic of Korea",
    "Indonesia",
    "India",
    "Thailand",
    "Philippines",
    "Viet Nam",
    "Singapore",
    "Malaysia",
    "United States of America",
    "United Kingdom",
    "Germany",
    "France",
    "Italy",
    "Spain",
    "Other",
  ];

  countries.forEach((country) => {
    const option = document.createElement("option");
    option.value = country;
    option.textContent = country;
    select.appendChild(option);
  });

  select.value = "Japan";
  countryInput.value = "Japan";

  function applyCountryColor() {
    if (select.value === "ー") {
      select.style.color = "#999";
    } else {
      select.style.color = "";
    }
  }

  select.addEventListener("change", () => {
    countryInput.value = select.value === "ー" ? "" : select.value;
    applyCountryColor();
  });

  applyCountryColor();
  field.appendChild(select);
  FormElements.countrySelect = select;
}

// ----------------------------
// 「マザーハウスを知ったきっかけ」プルダウン化
// ----------------------------
function setupReferralSourceSelect() {
  const { referralSourceInput } = FormElements;
  if (!referralSourceInput) return;

  const field = referralSourceInput.closest(".socialplus-form-field");
  referralSourceInput.style.display = "none";

  const select = document.createElement("select");
  select.className = "referral-source-select";
  Object.assign(select.style, CONSTANTS.SELECT_STYLE);
  select.appendChild(new Option("選択してください", "", true, true));

  const options = [
    "店頭を見て",
    "知人から聞いて",
    "TV",
    "ラジオ",
    "新聞",
    "web",
    "「裸でも生きる」",
    "本・雑誌",
    "講演会",
    "ご家族・知人からの紹介",
    "Facebookやinstagram等のSNS",
    "インターネットでの検索",
    "マザーハウス以外のウェブサイト・ブログ",
    "マザーハウス書籍",
    "その他の書籍・雑誌",
    "その他",
  ];

  options.forEach((opt) => {
    select.appendChild(new Option(opt, opt));
  });

  function applyReferralSourceColor() {
    if (select.value === "") {
      select.style.color = "#999";
    } else {
      select.style.color = "";
    }
  }

  select.addEventListener("change", () => {
    referralSourceInput.value = select.value;
    applyReferralSourceColor();
  });

  applyReferralSourceColor();
  field.appendChild(select);
  FormElements.referralSourceSelect = select;
}

// ----------------------------
// DM可否チェックボックス化
// ----------------------------
function setupDmConsentCheckbox() {
  const { dmConsentInput } = FormElements;
  if (!dmConsentInput) return;

  const field = dmConsentInput.closest(".socialplus-form-field");
  dmConsentInput.style.display = "none";

  const label = field.querySelector(`label[for='${dmConsentInput.id}']`);
  if (label) {
    label.style.display = "block";
    label.textContent = "郵送でのご案内";
  }

  const wrapper = document.createElement("label");
  Object.assign(wrapper.style, CONSTANTS.CHECKBOX_STYLE);

  const checkbox = document.createElement("input");
  checkbox.type = "checkbox";
  checkbox.checked = true;
  checkbox.className = "custom-checkbox";
  dmConsentInput.value = checkbox.checked ? "True" : "False";

  checkbox.addEventListener("change", () => {
    dmConsentInput.value = checkbox.checked ? "True" : "False";
  });

  wrapper.appendChild(checkbox);
  wrapper.appendChild(
    document.createTextNode("新商品やイベントの情報を郵送で受け取る")
  );
  field.appendChild(wrapper);
  FormElements.dmConsentCheckbox = checkbox;
}

// ----------------------------
// メルマガ同意チェックボックス化 + グループ化
// ----------------------------
function setupConsentCheckbox(input, labelText) {
  if (!input) return null;

  input.style.display = "none";

  const field = input.closest(".socialplus-form-field");
  const label = field.querySelector(`label[for='${input.id}']`);
  if (label) label.style.display = "none";

  const wrapper = document.createElement("label");
  Object.assign(wrapper.style, CONSTANTS.CHECKBOX_STYLE);

  const checkbox = document.createElement("input");
  checkbox.type = "checkbox";
  checkbox.checked = true;
  checkbox.className = "custom-checkbox";
  input.value = checkbox.checked ? "True" : "False";

  checkbox.addEventListener("change", () => {
    input.value = checkbox.checked ? "True" : "False";
  });

  wrapper.appendChild(checkbox);
  wrapper.appendChild(document.createTextNode(labelText));
  field.appendChild(wrapper);
  return wrapper;
}

function groupEmailConsentCheckboxes(mhWrapper, eyWrapper) {
  if (!mhWrapper || !eyWrapper) return;

  const { mhMailConsentInput } = FormElements;
  const mhField = mhMailConsentInput.closest(".socialplus-form-field");

  const group = document.createElement("div");
  group.className = "socialplus-form-field-email-consent-group";
  group.appendChild(mhWrapper);
  group.appendChild(eyWrapper);

  const heading = document.createElement("div");
  heading.textContent = "メールでのご案内";
  heading.style.fontSize = "16px";
  heading.style.marginBottom = "8px";

  const label = mhField.querySelector(
    `label[for='${FormElements.mhMailConsentInput.id}']`
  );
  if (label) label.style.display = "none";

  mhField.insertBefore(heading, mhField.firstChild);
  mhField.appendChild(group);
}

// ----------------------------
// 生年月日PlaceHolder調整 + バリデーション
// ----------------------------
function setupBirthdateFields() {
  const { yearSelect, monthSelect, daySelect, birthdateLabel } = FormElements;
  if (!yearSelect || !monthSelect || !daySelect) return;

  // required属性を削除
  yearSelect.removeAttribute("required");
  monthSelect.removeAttribute("required");
  daySelect.removeAttribute("required");

  // 年のプレースホルダー処理
  const yearPlaceholderOption = yearSelect.querySelector('option[value=""]');
  if (yearPlaceholderOption) {
    // 既存のプレースホルダーを削除
    yearPlaceholderOption.remove();
  }

  // プレースホルダー用のオプションを作成
  const placeholder = document.createElement("option");
  placeholder.value = "";
  placeholder.textContent = "年";
  placeholder.dataset.placeholder = "2000";
  placeholder.style.color = "#999";

  // 1999と2000の間に挿入
  let inserted = false;
  for (let i = 0; i < yearSelect.options.length; i++) {
    if (yearSelect.options[i].value === "2000") {
      yearSelect.insertBefore(placeholder, yearSelect.options[i]);
      inserted = true;
      break;
    }
  }
  // 見つからなかった場合は先頭に追加
  if (!inserted) {
    yearSelect.insertBefore(placeholder, yearSelect.firstChild);
  }
  yearSelect.value = "";

  // 月のプレースホルダー処理
  const monthPlaceholderOption = monthSelect.querySelector('option[value=""]');
  if (monthPlaceholderOption) {
    monthPlaceholderOption.textContent = "月";
    monthPlaceholderOption.dataset.placeholder = "1";
    monthPlaceholderOption.style.color = "#999";
  } else {
    const placeholder = document.createElement("option");
    placeholder.value = "";
    placeholder.textContent = "月";
    placeholder.dataset.placeholder = "1";
    placeholder.style.color = "#999";
    monthSelect.insertBefore(placeholder, monthSelect.firstChild);
  }
  monthSelect.value = "";

  // 日のプレースホルダー処理
  const dayPlaceholderOption = daySelect.querySelector('option[value=""]');
  if (dayPlaceholderOption) {
    dayPlaceholderOption.textContent = "日";
    dayPlaceholderOption.dataset.placeholder = "1";
    dayPlaceholderOption.style.color = "#999";
  } else {
    const placeholder = document.createElement("option");
    placeholder.value = "";
    placeholder.textContent = "日";
    placeholder.dataset.placeholder = "01";
    placeholder.style.color = "#999";
    daySelect.insertBefore(placeholder, daySelect.firstChild);
  }
  daySelect.value = "";

  const dateGroup = yearSelect.closest(".socialplus-form-date-group");
  if (dateGroup) {
    // クラス追加
    dateGroup.classList.add("birthdate-field-group");

    // 元のセレクトを保存
    const origYearSelect = yearSelect;
    const origMonthSelect = monthSelect;
    const origDaySelect = daySelect;

    // 親要素をクリアする
    while (dateGroup.firstChild) {
      dateGroup.removeChild(dateGroup.firstChild);
    }

    // スタイルを適用
    dateGroup.style.display = "block";

    // 「年」
    const yearRow = document.createElement("div");
    yearRow.style.display = "flex";
    yearRow.style.alignItems = "center";
    yearRow.style.marginBottom = "10px";

    // セレクトボックスの幅設定
    origYearSelect.style.flex = "1";
    origYearSelect.style.maxWidth = "420px";
    origYearSelect.style.marginRight = "8px";
    yearRow.appendChild(origYearSelect);

    const yearLabel = document.createElement("span");
    yearLabel.textContent = "年";
    yearLabel.style.marginLeft = "10px";
    yearLabel.style.width = "20px";
    yearRow.appendChild(yearLabel);

    // 「月」
    const monthRow = document.createElement("div");
    monthRow.style.display = "flex";
    monthRow.style.alignItems = "center";
    monthRow.style.marginBottom = "10px";

    // セレクトボックスの幅設定
    origMonthSelect.style.flex = "1";
    origMonthSelect.style.maxWidth = "420px";
    origMonthSelect.style.marginRight = "8px";
    monthRow.appendChild(origMonthSelect);

    const monthLabel = document.createElement("span");
    monthLabel.textContent = "月";
    monthLabel.style.marginLeft = "10px";
    monthLabel.style.width = "20px";
    monthRow.appendChild(monthLabel);

    // 「日」
    const dayRow = document.createElement("div");
    dayRow.style.display = "flex";
    dayRow.style.alignItems = "center";

    // セレクトボックスの幅設定
    origDaySelect.style.flex = "1";
    origDaySelect.style.maxWidth = "420px";
    origDaySelect.style.marginRight = "8px";
    dayRow.appendChild(origDaySelect);

    const dayLabel = document.createElement("span");
    dayLabel.textContent = "日";
    dayLabel.style.marginLeft = "10px";
    dayLabel.style.width = "20px";
    dayRow.appendChild(dayLabel);

    // dateGroupに追加
    dateGroup.appendChild(yearRow);
    dateGroup.appendChild(monthRow);
    dateGroup.appendChild(dayRow);
  }

  if (birthdateLabel) {
    birthdateLabel.innerHTML = "生年月日" + CONSTANTS.REQUIRED_MARK;
    birthdateLabel.style.fontSize = "16px";
  }

  // 見た目上のプレースホルダーを適用する
  const applyCustomPlaceholder = () => {
    if (yearSelect.value === "") {
      yearSelect.style.color = "#999";
      const placeholderOption = yearSelect.querySelector('option[value=""]');
      if (placeholderOption) {
        placeholderOption.textContent = placeholderOption.dataset.placeholder;
      }
    } else {
      yearSelect.style.color = "";
    }

    if (monthSelect.value === "") {
      monthSelect.style.color = "#999";
      const placeholderOption = monthSelect.querySelector('option[value=""]');
      if (placeholderOption) {
        placeholderOption.textContent = placeholderOption.dataset.placeholder;
      }
    } else {
      monthSelect.style.color = "";
    }

    if (daySelect.value === "") {
      daySelect.style.color = "#999";
      const placeholderOption = daySelect.querySelector('option[value=""]');
      if (placeholderOption) {
        placeholderOption.textContent = placeholderOption.dataset.placeholder;
      }
    } else {
      daySelect.style.color = "";
    }
  };

  // 初期表示と値変更時に適用
  applyCustomPlaceholder();

  // イベントリスナー追加
  yearSelect.addEventListener("change", () => {
    if (yearSelect.value === "") {
      const placeholderOption = yearSelect.querySelector('option[value=""]');
      if (placeholderOption) {
        placeholderOption.textContent = placeholderOption.dataset.placeholder;
      }
      yearSelect.style.color = "#999";
    } else {
      yearSelect.style.color = "";
    }
  });

  monthSelect.addEventListener("change", () => {
    if (monthSelect.value === "") {
      const placeholderOption = monthSelect.querySelector('option[value=""]');
      if (placeholderOption) {
        placeholderOption.textContent = placeholderOption.dataset.placeholder;
      }
      monthSelect.style.color = "#999";
    } else {
      monthSelect.style.color = "";
    }
  });

  daySelect.addEventListener("change", () => {
    if (daySelect.value === "") {
      const placeholderOption = daySelect.querySelector('option[value=""]');
      if (placeholderOption) {
        placeholderOption.textContent = placeholderOption.dataset.placeholder;
      }
      daySelect.style.color = "#999";
    } else {
      daySelect.style.color = "";
    }
  });

  // フォーカス時の挙動
  yearSelect.addEventListener("focus", () => {
    if (yearSelect.value === "") {
      const placeholderOption = yearSelect.querySelector('option[value=""]');
      if (placeholderOption) {
        placeholderOption.textContent = "年";
      }
    }
  });

  monthSelect.addEventListener("focus", () => {
    if (monthSelect.value === "") {
      const placeholderOption = monthSelect.querySelector('option[value=""]');
      if (placeholderOption) {
        placeholderOption.textContent = "月";
      }
    }
  });

  daySelect.addEventListener("focus", () => {
    if (daySelect.value === "") {
      const placeholderOption = daySelect.querySelector('option[value=""]');
      if (placeholderOption) {
        placeholderOption.textContent = "日";
      }
    }
  });

  // フォーカスを失った時の挙動
  yearSelect.addEventListener("blur", () => {
    if (yearSelect.value === "") {
      const placeholderOption = yearSelect.querySelector('option[value=""]');
      if (placeholderOption) {
        placeholderOption.textContent = placeholderOption.dataset.placeholder;
      }
    }
  });

  monthSelect.addEventListener("blur", () => {
    if (monthSelect.value === "") {
      const placeholderOption = monthSelect.querySelector('option[value=""]');
      if (placeholderOption) {
        placeholderOption.textContent = placeholderOption.dataset.placeholder;
      }
    }
  });

  daySelect.addEventListener("blur", () => {
    if (daySelect.value === "") {
      const placeholderOption = daySelect.querySelector('option[value=""]');
      if (placeholderOption) {
        placeholderOption.textContent = placeholderOption.dataset.placeholder;
      }
    }
  });
}

// ----------------------------
// バリデーション関数たち
// ----------------------------
// 姓名（カナ） → 全角カタカナ
function isValidKana(value) {
  return /^[ァ-ヶー]+$/.test(value);
}

// 電話番号 → 半角10〜11桁
function isValidPhone(value) {
  return /^\d{10,11}$/.test(value);
}

// 郵便番号 → 半角7桁
function isValidZip(value) {
  return /^\d{7}$/.test(value);
}

// ----------------------------
// エラーメッセージ削除関数
// ----------------------------
function clearAllErrors() {
  document
    .querySelectorAll(".validation-error-message")
    .forEach((el) => el.remove());

  document.querySelectorAll(".has-error").forEach((el) => {
    el.classList.remove("has-error");
    if (el.tagName === "INPUT" || el.tagName === "SELECT") {
      el.style.border = "1px solid #b9b9b9";
    }
  });

  const errorBanner = document.getElementById("validation-error-banner");
  if (errorBanner) errorBanner.remove();
}

// ----------------------------
// 全てのエラーが解消されたかチェックする関数
// ----------------------------
function checkAllErrorsCleared() {
  if (!document.querySelector(".has-error")) {
    const errorBanner = document.getElementById("validation-error-banner");
    if (errorBanner) errorBanner.remove();
  }
}

// ----------------------------
// エラーメッセージ追加
// ----------------------------
function addError(element, message, isDateGroup = false) {
  if (!element) return;

  const existing = element.parentNode.querySelectorAll(
    ".validation-error-message"
  );
  existing.forEach((el) => el.remove());

  const errorSpan = document.createElement("span");
  errorSpan.textContent = message;
  errorSpan.classList.add("validation-error-message");
  errorSpan.style.color = CONSTANTS.ERROR_COLOR;
  errorSpan.style.fontSize = CONSTANTS.ERROR_FONT_SIZE;
  errorSpan.style.marginTop = "4px";

  if (isDateGroup && FormElements.dateGroup?.parentNode) {
    FormElements.dateGroup.parentNode.insertBefore(
      errorSpan,
      FormElements.dateGroup.nextSibling
    );
    [
      FormElements.yearSelect,
      FormElements.monthSelect,
      FormElements.daySelect,
    ].forEach((el) => {
      el?.classList.add("has-error");
      if (el) el.style.border = `1px solid ${CONSTANTS.ERROR_COLOR}`;
    });
  } else {
    element.parentNode.insertBefore(errorSpan, element.nextSibling);
    if (
      element instanceof HTMLInputElement ||
      element instanceof HTMLSelectElement
    ) {
      element.classList.add("has-error");
      element.style.border = `1px solid ${CONSTANTS.ERROR_COLOR}`;
    }
  }
}

// ----------------------------
// エラーバナーの表示
// ----------------------------
function addErrorBanner() {
  const privacyLink = document.getElementById(
    "protection_of_personal_information_url"
  );
  if (!privacyLink || !privacyLink.parentNode) return;

  const errorBanner = document.createElement("div");
  errorBanner.id = "validation-error-banner";
  errorBanner.textContent =
    "申し訳ございませんが、ご入力頂いた内容に不備がございます。";

  Object.assign(errorBanner.style, {
    backgroundColor: "#FFE9E9",
    color: "#CC0000",
    padding: "10px",
    marginTop: "10px",
    marginBottom: "30px",
    borderRadius: "4px",
    fontSize: "14px",
    textAlign: "left",
  });

  privacyLink.parentNode.insertBefore(errorBanner, privacyLink);
}

// ----------------------------
// イベントバインド
// ----------------------------
function bindValidationEvents() {
  const {
    lastKana,
    firstKana,
    phoneInput,
    zipInput,
    yearSelect,
    monthSelect,
    daySelect,
    form,
  } = FormElements;

  // カナ（セイ・メイ）
  [lastKana, firstKana].forEach((field) => {
    if (!field) return;
    field.addEventListener("input", () => {
      const err = field.parentNode.querySelector(".validation-error-message");
      if (err) err.remove();
      field.classList.remove("has-error");
      field.style.border = "1px solid #b9b9b9";
      checkAllErrorsCleared();
    });
    field.addEventListener("blur", () => {
      if (!field.value.trim()) {
        addError(field, "入力必須項目です");
        field.classList.add("has-error");
        field.style.border = `1px solid ${CONSTANTS.ERROR_COLOR}`;
      } else if (!isValidKana(field.value)) {
        addError(field, "全角カタカナで入力してください");
        field.classList.add("has-error");
        field.style.border = `1px solid ${CONSTANTS.ERROR_COLOR}`;
      } else {
        field.classList.remove("has-error");
        field.style.border = "1px solid #b9b9b9";
      }
      checkAllErrorsCleared();
    });
  });

  //生年月日
  [
    FormElements.yearSelect,
    FormElements.monthSelect,
    FormElements.daySelect,
  ].forEach((el) => {
    el.addEventListener("change", () => {
      validateBirthdate();
    });
  });

  // 性別
  const genderRadios = form.querySelectorAll('input[name="gender_radio"]');
  genderRadios.forEach((radio) => {
    radio.addEventListener("change", () => {
      const group = FormElements.genderRadioGroup;
      const err = group?.parentNode?.querySelector(".validation-error-message");
      if (err) err.remove();

      group.querySelectorAll("input").forEach((el) => {
        el.classList.remove("has-error");
      });
      checkAllErrorsCleared();
    });
  });

  // 電話番号
  if (phoneInput) {
    phoneInput.addEventListener("input", () => {
      const err = phoneInput.parentNode.querySelector(
        ".validation-error-message"
      );
      if (err) err.remove();
      phoneInput.classList.remove("has-error");
      phoneInput.style.border = "1px solid #b9b9b9";
      checkAllErrorsCleared();
    });
    phoneInput.addEventListener("blur", () => {
      if (!phoneInput.value.trim()) {
        addError(phoneInput, "入力必須項目です");
        phoneInput.classList.add("has-error");
        phoneInput.style.border = `1px solid ${CONSTANTS.ERROR_COLOR}`;
      } else if (!isValidPhone(phoneInput.value)) {
        addError(
          phoneInput,
          "半角英数(ハイフンなし/10〜11桁)で入力してください"
        );
        phoneInput.classList.add("has-error");
        phoneInput.style.border = `1px solid ${CONSTANTS.ERROR_COLOR}`;
      } else {
        phoneInput.classList.remove("has-error");
        phoneInput.style.border = "1px solid #b9b9b9";
      }
      checkAllErrorsCleared();
    });
  }

  // 郵便番号
  if (zipInput) {
    zipInput.addEventListener("input", () => {
      const err = zipInput.parentNode.querySelector(
        ".validation-error-message"
      );
      if (err) err.remove();
      zipInput.classList.remove("has-error");
      zipInput.style.border = "1px solid #b9b9b9";
      checkAllErrorsCleared();
    });
    zipInput.addEventListener("blur", () => {
      if (!zipInput.value.trim()) {
        addError(zipInput, "入力必須項目です");
        zipInput.classList.add("has-error");
        zipInput.style.border = `1px solid ${CONSTANTS.ERROR_COLOR}`;
      } else if (!isValidZip(zipInput.value)) {
        addError(zipInput, "半角英数(ハイフンなし/7桁)で入力してください");
        zipInput.classList.add("has-error");
        zipInput.style.border = `1px solid ${CONSTANTS.ERROR_COLOR}`;
      } else {
        zipInput.classList.remove("has-error");
        zipInput.style.border = "1px solid #b9b9b9";
      }
      checkAllErrorsCleared();
    });
  }

  // 他の required input 項目
  const otherRequired = form.querySelectorAll("[required]");
  otherRequired.forEach((field) => {
    field.addEventListener("input", () => {
      const err = field.parentNode.querySelector(".validation-error-message");
      if (err) err.remove();
      field.classList.remove("has-error");
      field.style.border = "1px solid #b9b9b9";
      checkAllErrorsCleared();
    });
    field.addEventListener("blur", () => {
      if (!field.value.trim()) {
        addError(field, "入力必須項目です");
      } else {
        field.classList.remove("has-error");
        field.style.border = "1px solid #b9b9b9";
      }
      checkAllErrorsCleared();
    });
  });
}

// ----------------------------
// 生年月日バリデーション関数
// ----------------------------
function validateBirthdate() {
  const { yearSelect, monthSelect, daySelect, dateGroup } = FormElements;
  if (!yearSelect || !monthSelect || !daySelect) return true;

  const year = yearSelect.value.trim();
  const month = monthSelect.value.trim();
  const day = daySelect.value.trim();

  const errorEl = dateGroup?.parentNode?.querySelector(
    ".validation-error-message"
  );
  if (!year || !month || !day) {
    if (!errorEl) {
      addError(dateGroup, "入力必須項目です", true);
    }

    [yearSelect, monthSelect, daySelect].forEach((el) => {
      if (!el.value.trim()) {
        el.classList.add("has-error");
        el.style.border = `1px solid ${CONSTANTS.ERROR_COLOR}`;
      }
    });

    return false;
  } else {
    if (errorEl) errorEl.remove();
    [yearSelect, monthSelect, daySelect].forEach((el) => {
      el.classList.remove("has-error");
      el.style.border = "1px solid #b9b9b9";
    });
    checkAllErrorsCleared();
    return true;
  }
}

// ----------------------------
// Submit制御（全項目バリデーション）
// ----------------------------
function validateAndSubmit(event) {
  event.preventDefault();
  clearAllErrors();

  let hasErrors = false;
  const { form } = FormElements;

  // 性別（ラジオボタン）
  const selectedGender = form.querySelector(
    'input[name="gender_radio"]:checked'
  );
  if (!selectedGender) {
    addError(FormElements.genderRadioGroup, "入力必須項目です");
    const radios = FormElements.genderRadioGroup.querySelectorAll(
      'input[type="radio"]'
    );
    radios.forEach((r) => r.classList.add("has-error"));
    hasErrors = true;
  }

  // 生年月日（セレクト縦並び）
  if (!validateBirthdate()) {
    hasErrors = true;
  }

  // 都道府県（カスタムセレクト）
  if (FormElements.prefectureSelect && !FormElements.prefectureSelect.value) {
    addError(FormElements.prefectureSelect, "入力必須項目です");
    FormElements.prefectureSelect.classList.add("has-error");
    FormElements.prefectureSelect.style.border = `1px solid ${CONSTANTS.ERROR_COLOR}`;
    hasErrors = true;
  }

  // その他の [required] フィールド
  const requiredFields = form.querySelectorAll("[required]");
  requiredFields.forEach((field) => {
    const id = field.id;
    const value = field.value.trim();

    // カナ（セイ・メイ）
    if (
      id === "customer_custom_fields_0_value" ||
      id === "customer_custom_fields_1_value"
    ) {
      if (!value) {
        addError(field, "入力必須項目です");
        hasErrors = true;
      } else if (!isValidKana(value)) {
        addError(field, "全角カタカナで入力してください");
        hasErrors = true;
      }
      return;
    }

    // 電話番号
    if (id === "customer_custom_fields_4_value") {
      if (!value) {
        addError(field, "入力必須項目です");
        hasErrors = true;
      } else if (!isValidPhone(value)) {
        addError(field, "ハイフン無しで入力してください");
        hasErrors = true;
      }
      return;
    }

    // 郵便番号
    if (id === "customer_custom_fields_5_value") {
      if (!value) {
        addError(field, "入力必須項目です");
        hasErrors = true;
      } else if (!isValidZip(value)) {
        addError(field, "正しい桁数を入力してください");
        hasErrors = true;
      }
      return;
    }

    // その他の通常フィールド
    if (!value) {
      addError(field, "入力必須項目です");
      hasErrors = true;
    }
  });

  // エラーあればバナー表示
  if (hasErrors) {
    addErrorBanner();
    return;
  }

  // エラーなければ送信
  form.submit();
}

// ----------------------------
// CSS調整
// ----------------------------
function injectCustomStyles() {
  const style = document.createElement("style");
  style.textContent = `
    /* ヘッダーと見出しの余白を設定 */
    .socialplus-form-header {
    margin-top: 50px;
    text-align: left;
    font-size: 20px;
    }

    /* Wrapperのpaddingを消す */
    .socialplus-form-outer-wrapper {
    padding-top: 0px;
    }

    /* スマートフォン用（768px以下）の上余白設定 */
    @media screen and (max-width: 768px) {
    .socialplus-form-header {
    margin-top: 20px;
    }
    }

    /* 各入力項目間の余白を30pxに設定 */
    .socialplus-form-field {
    margin-bottom: 30px;
    }

    /* 姓名・姓名（カナ）の入力項目間の余白を微調整 */
    #socialplus-customer-registration-form > div.socialplus-form-field-group.clearfix > div:nth-child(1),
    #socialplus-customer-registration-form > div.socialplus-form-field-kana-group.clearfix > div:nth-child(1) {
    margin-bottom: 10px !important;
    }

    /* 郵便番号入力欄の幅を150pxに */
    #customer_custom_fields_5_value {
      width: 150px;
    }

    /* セレクトの枠線統一 */
    .socialplus-form-date-group select,
    .prefecture-select,
    .country-select,
    .referral-source-select {
      border: 1px solid #b9b9b9 !important;
      border-radius: 2px !important;
      background-color: #fff !important;
    }
    
    /* プレースホルダー表示（value=""）の文字色をグレーに */
    .socialplus-form-date-group select option[value=""],
    .prefecture-select option[value=""],
    .country-select option[value=""],
    .referral-source-select option[value=""] {
      color: #999 !important;
    }
    
    /* 選択済みのoptionは通常色に戻す */
    .socialplus-form-date-group select:not(:focus) option:not(:checked),
    .prefecture-select:not(:focus) option:not(:checked),
    .country-select:not(:focus) option:not(:checked),
    .referral-source-select:not(:focus) option:not(:checked) {
      color: initial !important;
    }
    
    /* 生年月日セレクトの横並び調整 */
    .socialplus-form-date-group .year,
    .socialplus-form-date-group .month,
    .socialplus-form-date-group .day {
      max-width: 420px !important;
      margin-right: 8px !important;
    }
    
    /* エラーメッセージの見た目 */
    .validation-error-message {
      display: block;
      margin-top: 4px;
      font-size: 14px;
    }
    
    /* メールアドレス欄の枠線 */
    input[name="customer[email]"] {
      border: 1px solid #b9b9b9;
    }

    .privacy-link {
      color: #000;
      text-decoration: underline;
    }

    /* エラー時の赤枠強制適用 */
    select.has-error,
    input.has-error {
      border: 1px solid ${CONSTANTS.ERROR_COLOR} !important;
    }
  
    /* プレースホルダー色 */
    select option[value=""] {
      color: #999;
    }
  
    /* 選択後の正常色戻し */
    select:not(:focus):not(.has-error) {
      border: 1px solid #b9b9b9;
      color: #000;
    }

    /* ログインリンク */
    .socialplus-form-description a {
      text-decoration: none;
      color: blue;
    }

    /* チェックボックスのスタイル */
    .custom-checkbox {
      min-width: 20px;
      min-height: 20px;
      margin-right: 10px !important;
      accent-color: rgb(101, 101, 101);
    }
    
    /* ラジオボタンのスタイル */
    input[type="radio"] {
      accent-color: rgb(101, 101, 101);
      width: 25px !important;
      height: 25px !important;
    }
    
    /* 性別ラジオボタングループ */
    .gender-radio-group {
      gap: 35px !important;
    }

    /* 送信ボタンエリアの下余白設定 */
    .socialplus-form-submit {
      margin-bottom: 100px !important;
    }
  `;
  document.head.appendChild(style);
}

// ----------------------------
// DOMContentLoaded：全処理初期化
// ----------------------------
document.addEventListener("DOMContentLoaded", () => {
  //「前回のログイン」の文言を削除
  const loginMsg = document.querySelector(
    ".socialplus-login-button-last-login"
  );
  if (loginMsg) loginMsg.remove();

  //オレンジ色の枠を削除
  const loginLink = document.querySelector(".socialplus-login-button-link");
  if (loginLink) {
    loginLink.style.border = "none";
    loginLink.style.outline = "none";
  }

  FormElements.init();
  if (!FormElements.form) return;

  UI.applyRequiredMarks();
  UI.setPlaceholders();
  UI.adjustNameFieldStructure();
  UI.styleSubmitButton();

  setupGenderField();
  setupPrefectureSelect();
  setupCountrySelect();
  setupReferralSourceSelect();

  setupDmConsentCheckbox();
  const mhCheckbox = setupConsentCheckbox(
    FormElements.mhMailConsentInput,
    "マザーハウスに関する新商品やイベントに関する情報を受け取る"
  );
  const eyCheckbox = setupConsentCheckbox(
    FormElements.eyMailConsentInput,
    "ERIKO YAMAGUCHIに関する新商品やイベントに関する情報を受け取る"
  );
  groupEmailConsentCheckboxes(mhCheckbox, eyCheckbox);

  setupBirthdateFields();
  bindValidationEvents();
  injectCustomStyles();

  if (FormElements.submitButton) {
    FormElements.submitButton.addEventListener("click", validateAndSubmit);
  }

  const oldLink = document.getElementById(
    "protection_of_personal_information_url"
  );
  if (oldLink) {
    const replacement = document.createElement("p");
    replacement.id = "protection_of_personal_information_url";
    replacement.className = "privacy-text";
    replacement.innerHTML =
      '※会員登録いただくことによって、マザーハウスの<a href="https://www.motherhouse.co.jp/pages/privacy-policy" class="privacy-link" target="_blank" rel="noopener noreferrer">プライバシーポリシー</a>にご同意いただいたものとみなします。';

    Object.assign(replacement.style, {
      textAlign: "left",
      fontSize: "14px",
    });

    oldLink.replaceWith(replacement);
  }
});
